<template>
  <div
    class="modal topup-modal offer-modal accept-offer-modal contact-info-modal"
  >
    <div class="overlay" @click="closeModal"></div>
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img
              class="close"
              @click="closeModal"
              src="./../images/close.svg"
            />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="cart-up">
                  <!-- Step 1: Contact Information -->
                  <div class="bottom" v-if="step === 1">
                    <div class="cart-top">
                      <div class="desc">
                        <b>CONTACT INFORMATION</b>
                      </div>
                    </div>
                    <div class="offer-wrapper topup-form spec-form">
                      <label class="input-container">
                        <input type="text" placeholder="Name" v-model="name" />
                      </label>
                      <label class="input-container">
                        <input
                          type="text"
                          placeholder="Surname"
                          v-model="surname"
                        />
                      </label>
                      <label class="input-container">
                        <input
                          type="email"
                          placeholder="E-mail address"
                          v-model="email"
                        />
                      </label>
                      <label class="input-container">
                        <input type="tel" placeholder="Phone" v-model="phone" />
                      </label>
                      <label class="input-container">
                        <select v-model="country">
                          <option value="" disabled selected>Country</option>
                          <option
                            v-for="(item, i) in countryOptions"
                            :value="item.title"
                            :key="i"
                          >
                            {{ item.title }}
                          </option>
                        </select>
                      </label>
                      <label class="input-container">
                        <input type="text" placeholder="City" v-model="city" />
                      </label>
                      <label class="input-container">
                        <input
                          type="text"
                          placeholder="Address"
                          v-model="address"
                        />
                      </label>
                      <label class="input-container">
                        <input
                          type="text"
                          placeholder="Post Code"
                          v-model="postCode"
                        />
                      </label>
                    </div>

                    <div class="payout-method-selection">
                      <div class="selection-title">CHOOSE PAYOUT METHOD</div>
                      <div class="buttons-special">
                        <button
                          class="button"
                          :disabled="!isContactInfoValid"
                          @click="goToIbanStep"
                        >
                          IBAN
                        </button>
                        <button
                          class="button red"
                          :disabled="!isContactInfoValid"
                          @click="payoutWithCard"
                        >
                          Card
                        </button>
                      </div>
                    </div>

                    <transition name="slide">
                      <div
                        v-if="formError"
                        class="error-desc desc red error-box"
                      >
                        {{ formError }}
                      </div>
                    </transition>
                  </div>

                  <!-- Step 2: IBAN Details -->
                  <div class="bottom" v-if="step === 2">
                    <div class="cart-top cart-top-spec">
                      <div class="desc active">
                        <b>IBAN TRANSFER</b>
                      </div>
                    </div>
                    <div class="offer-wrapper topup-form">
                      <label class="input-container">
                        <input
                          type="text"
                          v-model="bank_holder_name"
                          placeholder="First Name"
                        />
                      </label>
                      <label class="input-container">
                        <input
                          type="text"
                          v-model="bank_holder_surname"
                          placeholder="Last Name"
                        />
                      </label>
                      <label class="input-container">
                        <input
                          type="text"
                          maxlength="34"
                          v-model="iban_number"
                          placeholder="IBAN"
                        />
                      </label>
                      <div class="cta-container">
                        <label class="chekbox-label">
                          <div class="chekbox-label-wrapper">
                            <input
                              type="checkbox"
                              name="terms"
                              v-model="terms"
                            />
                            <div class="checkbox"></div>
                            <span class="title">I agree with </span>
                            <a @click="goToPrivacy" class="title"
                              >privacy policy</a
                            >
                            <span class="title"> and </span>
                            <a @click="goToTerms" class="title"
                              >terms and conditions</a
                            >
                          </div>
                        </label>
                      </div>
                    </div>
                    <div class="buttons-special">
                      <button class="button" @click="step = 1">Back</button>
                      <button
                        class="button red"
                        :disabled="!isIbanFormValid"
                        @click="confirmIbanPayout"
                      >
                        Confirm
                      </button>
                    </div>
                    <transition name="slide">
                      <div
                        v-if="formError"
                        class="error-desc desc red error-box"
                      >
                        {{ formError }}
                      </div>
                    </transition>
                  </div>

                  <!-- Step 3: Success Message -->
                  <div class="bottom" v-if="step === 3">
                    <div class="cart-top cart-top-spec">
                      <div class="desc active">
                        <b>PAYOUT REQUEST SUCCESSFUL</b>
                      </div>
                    </div>
                    <div class="offer-wrapper topup-form">
                      <div class="success-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="64"
                          height="64"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#4CAF50"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                          <polyline points="22 4 12 14.01 9 11.01"></polyline>
                        </svg>
                      </div>
                      <div class="success-text">
                        Your payout request has been successfully submitted.
                        Your funds will be transferred to your bank account
                        soon.
                      </div>
                    </div>
                    <div class="buttons-special">
                      <button class="button red" @click="closeModal">
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AcceptOfferModal",
  props: {
    orderToView: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      step: 1,
      name: "",
      surname: "",
      email: "",
      phone: "",
      country: "",
      city: "",
      address: "",
      postCode: "",
      countryOptions: [],

      iban_number: "",
      bank_holder_name: "",
      bank_holder_surname: "",
      terms: false,

      formError: "",
      isLoading: false,
    };
  },
  computed: {
    isContactInfoValid() {
      return (
        this.name &&
        this.surname &&
        this.email &&
        this.phone &&
        this.country &&
        this.city &&
        this.address &&
        this.postCode
      );
    },
    isIbanFormValid() {
      return (
        this.bank_holder_name &&
        this.bank_holder_surname &&
        this.iban_number &&
        this.terms
      );
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeAcceptOfferModal");
      // Defensive: reset all form fields and errors
      this.step = 1;
      this.formError = "";
      this.bank_holder_name = "";
      this.bank_holder_surname = "";
      this.iban_number = "";
      this.terms = false;
      this.name = "";
      this.surname = "";
      this.email = "";
      this.phone = "";
      this.country = "";
      this.city = "";
      this.address = "";
      this.postCode = "";
    },
    getContactInfoPayload() {
      // Check if orderToView has a valid ID
      if (!this.orderToView || typeof this.orderToView.id === 'undefined' || this.orderToView.id === null) {
        this.formError = "Invalid offer data. Missing offer ID.";
        this.$emit("setError", this.formError);
        return null;
      }

      return {
        id: this.orderToView.id,
        currency: this.orderToView.currency || 'EUR',
        name: this.name,
        surname: this.surname,
        email: this.email,
        phone: this.phone,
        country: this.country,
        city: this.city,
        address: this.address,
        postCode: this.postCode,
      };
    },
    payoutWithCard() {
      this.formError = "";
      
      // Check if orderToView has a valid ID
      if (!this.orderToView || typeof this.orderToView.id === 'undefined' || this.orderToView.id === null) {
        this.formError = "Invalid offer data. Missing offer ID.";
        this.$emit("setError", this.formError);
        return;
      }
      
      // Validate all required fields
      if (!this.name) {
        this.formError = "Please enter your name.";
        return;
      }
      if (!this.surname) {
        this.formError = "Please enter your surname.";
        return;
      }
      if (!this.email) {
        this.formError = "Please enter your email.";
        return;
      }
      if (!this.phone) {
        this.formError = "Please enter your phone number.";
        return;
      }
      if (!this.country) {
        this.formError = "Please select a country.";
        return;
      }
      if (!this.city) {
        this.formError = "Please enter your city.";
        return;
      }
      if (!this.address) {
        this.formError = "Please enter your address.";
        return;
      }
      if (!this.postCode) {
        this.formError = "Please enter your post code.";
        return;
      }

      const data = this.getContactInfoPayload();
      if (!data) return;

      this.isLoading = true;
      this.$http
        .post(`${process.env.VUE_APP_API}offer/request-payout/card-form`, data)
        .then((res) => {
          this.isLoading = false;
          if (res.data && res.data.redirect_url) {
            window.location.href = res.data.redirect_url;
          } else {
            this.formError = "Could not retrieve payment URL. Please try again.";
            this.$emit("setError", this.formError);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.handleApiError(err);
        });
    },
    confirmIbanPayout() {
      this.formError = "";
      if (!this.isIbanFormValid) {
        this.formError = "Please fill in all IBAN fields and accept the terms.";
        return;
      }

      // Simple IBAN validation (not exhaustive)
      if (
        !/^[A-Z]{2}[0-9]{2}[A-Z0-9]{4,30}$/.test(
          this.iban_number.replace(/\s+/g, "")
        )
      ) {
        this.formError = "Please enter a valid IBAN.";
        return;
      }

      // Check if orderToView has a valid ID
      if (!this.orderToView || !this.orderToView.id) {
        this.formError = "Invalid offer data. Missing offer ID.";
        return;
      }

      const data = {
        id: this.orderToView.id,
        currency: this.orderToView.currency || 'EUR',
        first_name: this.bank_holder_name,
        last_name: this.bank_holder_surname,
        account_number: this.iban_number,
      };

      this.isLoading = true;
      this.$http
        .post(process.env.VUE_APP_API + "offer/request-payout/sepa-manual", data)
        .then((res) => {
          this.isLoading = false;
          if (res.data.status === "OK") {
            this.step = 3; // Show success screen
            this.formError = "";

            // Refresh offer history in parent component if available
            if (
              this.$parent &&
              typeof this.$parent.getOfferHistory === "function"
            ) {
              this.$parent.getOfferHistory();
            } else if (
              this.$root &&
              typeof this.$root.getOfferHistory === "function"
            ) {
              this.$root.getOfferHistory();
            }
          } else {
            this.formError =
              res.data.message ||
              "An error occurred while processing your request.";
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.handleApiError(error);
        });
    },
    handleApiError(err) {
      if (err.response && err.response.data) {
        const data = err.response.data;
        if (data.errors) {
          // Get the first error message from any field
          const errorFields = Object.values(data.errors);
          if (errorFields.length > 0) {
            const firstErrorField = errorFields[0];
            this.formError = Array.isArray(firstErrorField) && firstErrorField.length > 0
              ? firstErrorField[0]
              : "Validation failed.";
          } else {
            this.formError = "Validation failed.";
          }
        } else {
          this.formError = data.message || "An unexpected error occurred.";
        }
      } else {
        this.formError = "A network error occurred. Please try again.";
      }
      
      // Also emit the error to parent components
      this.$emit("setError", this.formError);
    },
    goToTerms() {
      this.$emit("goToPage", "terms");
    },
    goToPrivacy() {
      this.$emit("goToPage", "privacy");
    },
    goToIbanStep() {
      this.formError = "";
      
      // Check if orderToView has a valid ID
      if (!this.orderToView || typeof this.orderToView.id === 'undefined' || this.orderToView.id === null) {
        this.formError = "Invalid offer data. Missing offer ID.";
        this.$emit("setError", this.formError);
        return;
      }
      
      // Validate all required fields
      if (!this.name) {
        this.formError = "Please enter your name.";
        return;
      }
      if (!this.surname) {
        this.formError = "Please enter your surname.";
        return;
      }
      if (!this.email) {
        this.formError = "Please enter your email.";
        return;
      }
      if (!this.phone) {
        this.formError = "Please enter your phone number.";
        return;
      }
      if (!this.country) {
        this.formError = "Please select a country.";
        return;
      }
      if (!this.city) {
        this.formError = "Please enter your city.";
        return;
      }
      if (!this.address) {
        this.formError = "Please enter your address.";
        return;
      }
      if (!this.postCode) {
        this.formError = "Please enter your post code.";
        return;
      }

      this.step = 2;
    },
    fetchInitialData() {
      this.$http
        .get(process.env.VUE_APP_API + "countries")
        .then((res) => {
          this.countryOptions = res.data.payload;
        })
        .catch(() => {
          this.formError = "Could not load countries.";
        });

      this.$http
        .get(process.env.VUE_APP_API + "user/profile")
        .then((res) => {
          this.email = res.data.email;
          this.name = res.data.name;
          this.surname = res.data.surname;
          this.phone = res.data.phone;
        })
        .catch(() => {
          this.$emit("openSignIn");
        });
    },
    validateOrderToView() {
      // Check if orderToView has a valid ID
      if (!this.orderToView || typeof this.orderToView.id === 'undefined' || this.orderToView.id === null) {
        this.formError = "Invalid offer data. Missing offer ID.";
        this.$emit("setError", this.formError);
        return false;
      }
      return true;
    },
  },
  mounted() {
    this.fetchInitialData();
    
    // Check if orderToView is valid
    this.validateOrderToView();
  },
  watch: {
    orderToView(newVal) {
      if (newVal) {
        this.step = 1;
        this.formError = "";
        
        // Validate the new orderToView
        this.validateOrderToView();
      }
    },
  },
};
</script>

<style scoped>
.payout-method-selection {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
.selection-title {
  text-align: center;
  font-weight: 700;
  margin-bottom: 16px;
  color: #fff;
  font-size: 16px;
}
.buttons-special {
  display: flex;
  gap: 16px;
  justify-content: center;
}
.buttons-special .button {
  flex: 1;
}
.success-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px;
}
.success-icon {
  text-align: center;
  margin-bottom: 24px;
}
.success-text {
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 24px;
}
.error-desc {
  margin-top: 16px;
  text-align: center;
}
.error-box {
  background-color: rgba(255, 0, 0, 0.2);
  color: white;
  padding: 10px;
  border-radius: 4px;
  margin-top: 16px;
  font-weight: bold;
}
</style>
